import { Col, Container, Row } from "react-bootstrap"
import styled from "styled-components"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"
import { Trans, useTranslation } from "~/i18n"
import getcdn from "~/modules/get_cdn_link"
import breakpoints from "~/components/UI/breakpoints"
import Button from "~/components/UI/Button"
import Image from "~/components/UI/Image"
import isMobileSize from '~/modules/isMobileSize'
import { ROUTES } from "~/constant"
import { ReactChild } from "react"
import { observer } from "mobx-react-lite"
import config from '~/stores/Config'

const MyContainer = styled(Box)`
  --height: auto;
  margin-bottom: 100px;
  padding-top: 30px;
  height: var(--height);
  background: linear-gradient(116deg, #0092ff, #0055ff);
  ${breakpoints.md} {
    background: #f9fafc;
    --height: 400px;
    padding-top: 0;
  }
  ${breakpoints.lg} {
    margin-bottom: 50px;
    --height: 530px;
  }
  :before {
    content: "";
    background-image: linear-gradient(116deg, #0092ff, #0055ff);
    position: absolute;
    height: calc(var(--height) + 60px);
    width: 80vw;
    right: 0;
    bottom: 0;
    display: none;
    ${breakpoints.md} {
      display: block;
    }
  }
`

export const BoxDetails = styled(Box)`
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 0 20px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.1);
`

const BoxImage = styled(Box)`
  position: relative;
  height: 400px;
  width: 280px;
  padding-top: 30px;
  display: none;
  ${breakpoints.md} {
    display: block;

  }
  ${breakpoints.lg} {
    height: 530px;
    width: 400px;
    img:nth-child(1) {
      height: 100%;
      width: auto;
    }
    img:nth-child(2) {
      height: auto;
      width: auto;
    }
  }
`

const BoxImageMobile = styled(Box)`
  position: relative;
  height: 350px;
  width: 300px;
  margin: auto;
  ${breakpoints.md} {
    display: none;
  }

`

export const DesktopBoxContent: React.FC<{
  profit: ReactChild | string
  term: string
  minBalance: string
}> = ({
  profit,
  term,
  minBalance
}) => {
    const [t] = useTranslation()
    const isMobile = isMobileSize()

    if (!isMobile) {
      return (
        <BoxDetails margin='20px 0' flex justify='space-between' align='center'>
          <Box height='auto'>
            <Text color='#fff'>
              {t('Lợi nhuận')}
            </Text>
            <Text size={18} lgSize={24} bold color='#fff'>
              {profit}
            </Text>
          </Box>

          <Box height='auto'>
            <Text color='#fff'>
              {t('Thời hạn')}
            </Text>
            <Text size={18} lgSize={24} bold color='#fff'>
              {term}
            </Text>
          </Box>

          <Box height='auto'>
            <Text color='#fff'>
              {t('Vốn tối thiểu')}
            </Text>
            <Text size={18} lgSize={24} bold color='#fff'>
              {minBalance}
            </Text>
          </Box>
        </BoxDetails>
      )
    }

    return null
  }

const Saving = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <Row>
          <Col md={5}>
            <BoxImage>
              <Image src={getcdn('/images/home/iphone1.png?ver=1')} alt='ipad_saving' height={400} width={280} />
              <Image
                xsStyle={{
                  position: 'absolute',
                  bottom: -100,
                  right: -50
                }}
                mdStyle={{
                  bottom: -100,
                  right: -53
                }}
                lgStyle={{
                  right: -50
                }}
                src={getcdn('/images/home/iphone2.png?ver=1')} alt='ipad_saving' height={400} width={280} />
            </BoxImage>
          </Col>
          <Col sm={12} md={7}>
            <Box
              flex column height='100%'
              mdStyle={{ paddingLeft: '2%', }}
            >
              <Text
                mdStyle={{ textAlign: 'left', padding: '0' }}
                xsStyle={{ textAlign: 'center', padding: '0 50px' }}
                color='#fff' size={36} lgSize={48} xlSize={56}>
                <Trans i18nKey='Tích luỹ linh hoạt'></Trans>
              </Text>
              <Text
                mdStyle={{ textAlign: 'left' }}
                xsStyle={{ textAlign: 'center' }}
                lgStyle={{ padding: '18px 0' }}
                color='#fff'
                size={24}
              >
                {t('Nhận tiền lời hàng tháng, rút tiền bất kỳ lúc nào.')}
              </Text>
              <Text
                mdStyle={{ textAlign: 'left' }}
                xsStyle={{ textAlign: 'center' }}
                color='#fff'
              >
                {t('Xây dựng thói quen tích lũy cho bản thân đồng thời tận dụng sức mạnh lãi kép để sinh lời nhanh chóng.')}
              </Text>
              <DesktopBoxContent
                profit={<CenterView>{config.saving?.interest + '%/' + t('năm')}{config.saving?.promo_interest && <DiscountBadge>{t('Ưu đãi')}</DiscountBadge>}</CenterView>}
                term={t('Linh hoạt')}
                minBalance={t('500 nghìn')}
              />
              <Button
                maxWidth='100%'
                xsStyle={{ margin: '30px 0', justifyContent: 'center' }}
                target='_blank'
                rel="noreferrer"
                link href={ROUTES.SAVING_INFO}
                border='0'
                mdStyle={{ justifyContent: 'flex-start', margin: '0' }}>
                <Text bold color='#fff'>
                  {t('Tìm hiểu thêm →')}
                </Text>
              </Button>

              <BoxImageMobile>
                <Image height={350} width={300} src={getcdn('/images/home/iphone1.png?ver=1')} alt='ipad_saving' />
                <Image
                  height={350} width={300}
                  style={{
                    position: 'absolute',
                    bottom: -60,
                    right: -30
                  }}
                  src={getcdn('/images/home/iphone2.png?ver=1')} alt='ipad_saving' />
              </BoxImageMobile>
            </Box>
          </Col>
        </Row>
      </Container>
    </MyContainer >
  )
}

export default observer(Saving)

const DiscountBadge = styled(Text)`
  margin-left: 5px;
  bottom: 25px;
  background-color: rgb(234, 32, 103);
  padding: 3px 4px;
  font-size: 10px;
  border-radius: 20px;
  display: inline-block;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
`

const CenterView = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
